module.exports = __webpack_public_path__ + "static/media/spanish-articles-table-2.dc1bfc68.PNG";